import { render, staticRenderFns } from "./exhibition-template-new-factory.vue?vue&type=template&id=d1ac0aa4&scoped=true&"
import script from "./exhibition-template-new-factory.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-new-factory.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-new-factory.vue?vue&type=style&index=0&id=d1ac0aa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ac0aa4",
  null
  
)

export default component.exports